import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportOptionsEditorComponent } from './component/transport-options-editor.component';
import { CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportOptionParameterComponent } from './transport-option-parameter/transport-option-parameter.component';
import { TransportOptionParameterSelectionComponent } from './transport-option-parameter-selection/transport-option-parameter-selection.component';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    TransportOptionsEditorComponent,
    TransportOptionParameterComponent,
    TransportOptionParameterSelectionComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    CommonUIModule,
    MatFormFieldModule,
    MatIconModule
  ],
  exports: [
    TransportOptionsEditorComponent
  ]
})
export class TransportOptionsEditorModule { }
